import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import EditProductSelectionFormContainer from './EditProductSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class EditProductSelectionModal extends Component {
  onSubmitSaveSelection = ({ name }) => {
    const condition = this.props.selections.map(sel => sel.name).includes(name !== undefined ? name.trim() : '');
    if (condition) {
      this.props.updateUI('error', 'app.admin.edit.preset.warning.message');
    } else {
      this.props.saveSelection({
        name,
        categories: this.props.categories,
      });
    }
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.edit.product.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <EditProductSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          selections={this.props.selections}
          categories={this.props.categories}
          name={this.props.name}
        />
      </Modal>
    );
  }
}

EditProductSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    scope: PropTypes.string,
    name: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({
      mailCategoryCode: PropTypes.string,
      mailSubClasses: PropTypes.arrayOf(PropTypes.string),
    })),
  })),
  categories: PropTypes.arrayOf(PropTypes.object),
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  name: PropTypes.string,
};

export default (EditProductSelectionModal);
